import { queryOptions } from "@tanstack/react-query";
import { getPricingCatalog } from "@/features/settings/server-fns";
import { publicPlans } from "./catalog";

export const pricingCatalogOptions = () =>
  queryOptions({
    queryKey: ["public", "pricing-catalog"],
    staleTime: 5 * 60_000,
    queryFn: async () => {
      try {
        const catalog = await getPricingCatalog();
        const plans = publicPlans(catalog ?? []);
        return plans.length ? plans : null;
      } catch {
        // Keep the public shell and FAQs usable during a catalog outage.
        return null;
      }
    },
  });
